import React from 'react';
import pathfinder from '@fiverr-private/pathfinder';
import { I18n } from '@fiverr-private/fiverr_context';
import { trackEvent } from '../../utils';
import { EVENT_TYPES } from '../../constants';

import './style.scss';

const NeedHelp = () => {

    const onClick = () => {
        trackEvent(EVENT_TYPES.CONTACT_SUPPORT);
    };

    return (
        <div className="need-help-container">
            <span><I18n k="layout.global_messages.user_activation.need_help"/></span>
            {/* eslint-disable react/jsx-no-target-blank */}
            <a href={pathfinder('help_center_homepage')} target="_blank" onClick={onClick}>
                <I18n k="layout.global_messages.user_activation.contact_support"/>
            </a>
        </div>
    );
};

export default NeedHelp;
